<template>
  <div class="container content border-left border-right">
    <div class="registration-form-container">
      <h2 class="text-center">
        Личный кабинет
      </h2>
      <p class="subtitle small">
        Основные возможности кабинета ЦТО
      </p>
      <div class="registration-form">
        <iframe
          width="580"
          height="326"
          src="https://www.youtube.com/embed/L_uYR7BLnbc"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        />

        <validation-observer v-slot="{handleSubmit}">
          <b-form class="mt-4" autocomplete="false" @submit.prevent="handleSubmit(save)">
            <input type="hidden" autocomplete="false">
            <validation-provider v-slot="{errors}">
              <b-form-group :invalid-feedback="errors[0]" class="d-flex justify-content-center">
                <b-form-checkbox
                  v-model="form.termsOfCooperationAcceptance"
                  size="sm"
                  class=""
                >
                  Принимаю <a href="/agreement.pdf" target="_blank" class="footer-link">
                    условия сотрудничества
                  </a>
                </b-form-checkbox>
              </b-form-group>
            </validation-provider>

            <validation-provider v-slot="{errors, valid, validated}" rules="required">
              <b-form-group
                label="Загрузите свидетельство регистрации"
                label-for="file-small"
                label-cols-sm="4"
                label-size="sm"
                :invalid-feedback="errors[0]"
              >
                <b-form-file
                  id="file-small"
                  v-model="form.registrationCertificate"
                  size="sm"
                  name="registrationCertificate"
                  :state="validated ? valid : null"
                  placeholder="Файл не выбран"
                />
              </b-form-group>
            </validation-provider>

            <b-form-group
              label-cols-sm="4"
              label-cols-lg="4"
              label-for="input-1"
              label-size="sm"
              :state="!ncalayerConnectionError"
              :invalid-feedback="WsErrorFeedback"
            >
              <template slot="label">
                Подписать <a :href="`/storage/${agreement.file}`" target="_blank" class="footer-link">договор</a> при помощи эцп
              </template>
              <ncalayer-button @click="sign">
                <template slot="connected-state">
                  {{ signButtonTitle }}
                </template>
              </ncalayer-button>
            </b-form-group>

            <validation-provider v-slot="{errors, valid, validated}" rules="required" vid="password">
              <b-form-group
                label-cols-sm="4"
                label-cols-lg="4"
                label="Придумайте пароль для авторизации в кабинете без ЭЦП. В качестве логина будет использоваться ваша электронная почта"
                label-for="input-1"
                label-size="sm"
                :invalid-feedback="errors[0]"
              >
                <b-form-input
                  id="input-1"
                  ref="password"
                  v-model="form.password"
                  type="password"
                  size="sm"
                  name="password"
                  :state="validated ? valid : null"
                  required
                  autocomplete="new-password"
                  placeholder="Введите пароль"
                />
              </b-form-group>
            </validation-provider>

            <validation-provider v-slot="{errors, valid, validated}" rules="required|confirmed_password:password">
              <b-form-group
                vid="confirmation"
                label-cols-sm="4"
                label-cols-lg="4"
                label="Повтор пароля"
                label-for="input-1"
                label-size="sm"
                :invalid-feedback="errors[0]"
              >
                <b-form-input
                  id="input-1"
                  v-model="form.passwordRepeat"
                  type="password"
                  size="sm"
                  name="passwordConfirmation"
                  data-vv-as="Повтор пароля"
                  :state="validated ? valid : null"
                  required
                  placeholder="Введите повтор пароля"
                />
              </b-form-group>
            </validation-provider>

            <div class="text-center">
              <p>
                <b-button
                  variant="primary"
                  class="small"
                  :disabled="!canSubmit"
                  type="submit"
                >
                  Отправить запрос
                </b-button>
              </p>
            </div>
          </b-form>
        </validation-observer>
      </div>
    </div>
  </div>
</template>

<script>
import { get, call } from 'vuex-pathify'
import NcalayerButton from '~/components/NcalayerButton'
export default {
  name: 'SecondStep',
  components: { NcalayerButton },
  data () {
    return {
      form: {
        termsOfCooperationAcceptance: false,
        signature: null,
        registrationCertificate: null,
        password: null,
        passwordRepeat: null
      }
    }
  },
  computed: {
    agreement: get('signup/agreement'),
    ncalayerConnected: get('ncalayer/isConnected'),
    ncalayerConnectionError: get('ncalayer/connectionError'),
    connectedWS () {
      return this.$store.state.socket.isConnected
    },
    WsError () {
      if (!this.$store.state.socket.isConnected) {
        return this.$store.state.socket.isConnected
      }
      return true
    },
    WsErrorFeedback () {
      if (!this.ncalayerConnected) {
        return 'NCAlayer не включен, включите его чтобы продолжить'
      }
      return null
    },
    registrationData () {
      return this.$store.state.registrationData
    },
    signButtonTitle () {
      return this.form.signature ? 'Договор подписан' : 'Подписать договор'
    },
    canSubmit () {
      return this.form.signature &&
        this.form.termsOfCooperationAcceptance &&
        !this.WsErrorFeedback
    }
  },
  methods: {
    ncalayerSendMessage: call('ncalayer/sendMessage'),
    submit: call('signup/submit'),
    async sign () {
      this.form.signature = await this.ncalayerSendMessage({ module: 'kz.gov.pki.knca.commonUtils', method: 'createCAdESFromBase64', args: ['PKCS12', 'SIGNATURE', this.agreement.hash, true] })
    },
    async save () {
      await this.submit(this.form)
    }
  }
}
</script>

<style>
.content {
  background-color: #ffffff;
  min-height: 100vh;
  padding: 200px 140px 87px 140px;
  border-color: #CAD0DF;
}

.registration-form {
  margin-top: 54px;
}

button.btn {
  margin-top: 64px;
  min-width: 260px;
}

.footer-link {
  color: #8392A5;
}
.registration-form iframe {
  margin-left: 140px;
}
.subtitle {
  text-align: center;
  margin-bottom: 40px;
  margin-top: 40px;
}
</style>
